<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('eu__self_test_previous_treatment__question')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('eu__self_test_previous_treatment__subtitle')"
        />
      </div>
      <div class="self-test">
        <fieldset class="form-container">
          <div
            v-for="option in PREVIOUS_TREATMENT_OPTIONS"
            :key="String(option.key)"
            :class="[
              'quiz-radio',
              { 'quiz-radio--checked': previousTreatment === option.key },
            ]"
            @click="setPreviousTreatment(option)"
          >
            <label class="quiz-radio__label kds-typography-title-medium">
              {{ $t(option.label) }}
            </label>
            <div class="quiz-radio__layout">
              <custom-radio
                :checked="previousTreatment === option.key"
                :data-qa="'previous-treatment-' + String(option.key)"
                :value="String(option.key)"
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="next"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'
import CustomRadio from '@shared/components/CustomRadio.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import { computed, ref } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import { preloadImage } from '@shared/utils/preloadImage'
import { PREVIOUS_TREATMENT_OPTIONS } from '@shared/modules/assessment/config/selfTestOptions'

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const selfTestStore = useSelfTestStore()
const { t } = useI18n()

const previousTreatment = ref(selfTestStore.previousTreatment)

const setPreviousTreatment = (option) => {
  previousTreatment.value = option.key
  preloadImage(option.image)
}

const isValid = computed(() => previousTreatment.value !== null)

const next = () => {
  const option = PREVIOUS_TREATMENT_OPTIONS.find(
    (o) => o.key === previousTreatment.value,
  )
  if (!option) return
  selfTestStore.answer('previous_treatment', {
    value: option.value,
    text: t(option.label),
    questionText: t('eu__self_test_previous_treatment__question'),
  })
  props.handleNextEvent()
}
</script>

<style lang="scss">
@use '@shared/modules/assessment/views/css/SelfTest.scss' as *;
</style>
